goog.provide('yext.entity.fields.ServiceArea');
goog.provide('yext.entity.fields.ServiceAreaModel');

/**
 * Service area field. A list of places served by a location
 *
 * @author MattJS (matt@yext.com)
 */
yext.entity.fields.ServiceArea = class {
  constructor($ctx) {
    this.$ctx = $ctx;
    this.$provideServiceArea = $ctx.find('.js-provide-service-area-checkbox');
    this.$placesList = $ctx.find('.js-places-list');
    this.$placesInput = $ctx.find('.js-service-area-places-input');

    this.placeTemplate = $ctx.find('.js-place-template').html();
    this.placesTemplate = $ctx.find('.js-service-area-places-template').html();
    this.model = this.extractModel();

    this.syncRecentPlaces();
    this.storeValue();
    this.bind();
    this.render();
  }

  /**
   * Store a copy of the fields current state
   */
  storeValue() {
    this.storedValue = this.getData();
  }

  /**
   * Extract the service area model from the DOM
   */
  extractModel() {
    let places;
    let $places = this.$placesList.find('li');
    if ($places.length) {
      places = $places.map((idx, li) => {
        return String($(li).data('place'));
      }).get();
    }
    return new yext.entity.fields.ServiceAreaModel({
      places,
    });
  }

  /**
   * All the field bindings
   * @suppress {deprecated}
   */
  bind() {
    let self = this;
    let $container = this.$ctx.find('.js-service-area-edit-container');

    this.$provideServiceArea.on('click, change', () => {
      let checked = this.$provideServiceArea.is(':checked');
      $container.toggle(checked);
      if (!checked) {
        this.model.clear();
      }
    });

    this.$placesInput.on('keypress', e => {
      if (e.which === $.ui.keyCode.ENTER) {
        // Stop the enter from submitting the form
        e.preventDefault();
        this.addCurrentPlacesInput();
        return false;
      }
    });

    this.$ctx.find('.js-add-service-area-place').on('click', () => {
      this.addCurrentPlacesInput();
    });

    this.$placesList.on('click', '.js-remove-place', function() {
      let place = $(this).closest('li').data('place');
      self.model.removePlace(String(place));
    });

    $(this.model).on('updated', () => {
      this.render();
      this.emitUpdate();
    });
  }

  /**
   * Set the recent places list to the model value, or empty array
   */
  syncRecentPlaces() {
    this.recentPlaces = this.model.places ? this.model.places.slice() : [];
  }

  /**
   * If the places input has a value, add to the places list
   */
  addCurrentPlacesInput() {
    if (this.$placesInput.val()) {
      this.model.pushPlace(String(this.$placesInput.val()));
      this.$placesInput.val('');
    }
  }

  /**
   * Return the string-keyed version of this field's model
   * @return {!Object}
   */
  getData() {
    return this.model.getData();
  }

  /**
   * Emit an message indicating that this field was updated
   */
  emitUpdate() {
    $(this).trigger('updated');
  }

  /**
   * Reset the field to its stored value
   */
  reset() {
    this.set(this.storedValue);
  }

  /**
   * Set the value of the field to the provided value
   * @param {!Object} data A plain object version of the field's model
   */
  set(data) {
    var field = {};
    if (data['places']) {
      field.places = data['places'].slice();
    }
    this.model.set(field);
    this.syncRecentPlaces();
    // Set the service area to be shown or hidden
    this.$provideServiceArea.prop('checked', !this.isEmpty()).trigger('change');
    this.render();
  }

  /**
   * Render the state of the field
   */
  render() {
    this.$placesList.empty();
    if (this.model.places) {
      this.model.places.forEach(place => {
        let placeHtml = this.placeTemplate.replace(/#PLACE/g, place);
        this.$placesList.append($(placeHtml));
      });
    }
  }

  /**
   * @return {boolean} True if the field empty
   */
  isEmpty() {
    return this.model.isEmpty();
  }

  /**
   * Get the display HTML for the field
   * @return {string}
   */
  getDisplayValue() {
    if (this.isEmpty()) {
      return yext.location.helpers.emptyFieldMessage();
    }
    if (this.model.places.length > 0) {
      return this.placesTemplate.replace(/#PLACES/g, this.model.places.join(', '));
    }
  }
};

/**
 * Model of this field that matches ServiceAreaView Java model in the App layer
 */
yext.entity.fields.ServiceAreaModel = class {
  constructor(data) {
    this.set(data);
  }

  /**
   * @param {!Object} data Plain object version of field
   */
  set(data) {
    this.places = data.places;
  }

  /**
   * Add a place to the places list
   * @param {string} place
   */
  pushPlace(place) {
    if (!(this.places instanceof Array)) {
      this.places = [];
    }
    this.places.push(place);
    this.emitUpdate();
  }

  /**
   * Set the places list
   * @param {!Array.<string>} places
   */
  setPlaces(places) {
    this.places = places;
    this.emitUpdate();
  }

  /**
   * Remove a place by value
   * @param {string} place
   */
  removePlace(place) {
    let index = this.places.indexOf(place);
    if (index !== -1) {
      this.places.splice(index, 1);
      this.emitUpdate();
    }
  }

  /**
   * Clear the places list
   */
  clearPlaces() {
    if (this.places) {
      this.places = [];
      this.emitUpdate();
    }
  }

  /**
   * Clear places
   */
  clear() {
    this.places = [];
    this.emitUpdate();
  }

  /**
   * Emit an update indicating the model has changed
   */
  emitUpdate() {
    $(this).trigger('updated');
  }

  /**
   * @return {boolean} True if empty
   */
  isEmpty() {
    return !this.places || this.places.length == 0;
  }

  /**
   * Return the string-keyed version of this model
   * @return {!Object}
   */
  getData() {
    let data = {};
    if (this.places) {
      data['places'] = this.places.slice();
    }
    return data;
  }
};
